(function($) {

	$('body').on('show_overlay', function (){
		$(this).addClass('has-overlay')
	})

	$('body').on('hide_overlay', function (){
		$(this).removeClass('has-overlay')
	})

})(jQuery);